import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'emotion-theming';

import Modal from '../Modal';
import Button from '../ButtonBit';
// eslint-disable-next-line import/no-unresolved
import { ReactComponent as TableIcon } from '../../assets/table.svg';
import {
  card,
  icon,
  titleText,
  subtitleText,
  tableInput,
  tableModalWrapper,
  tableModalInnerWrapper,
  tableModalContent,
} from './TableNumberModal.styles';

const TableNumberModal = ({ visible, onCloseModal, onConfirm }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [value, setValue] = useState('');

  const handleConfirm = () => {
    if (!value.trim()) return;
    onConfirm(value.trim());
    setValue('');
  };

  const handleChange = (e) => {
    setValue(e.target.value.replace(/\D/g, ''));
  };

  return (
    <Modal
      visible={visible}
      styles={{
        wrapper: tableModalWrapper,
        innerWrapper: tableModalInnerWrapper,
        content: tableModalContent,
      }}
      keepMounted
    >
      <div css={card}>
        <div css={icon}>
          <TableIcon color={theme.getColor('primary')} />
        </div>
        <span css={titleText}>{t('orderReview:tableNumberTitle')}</span>
        <span css={subtitleText}>{t('orderReview:tableNumberSubtitle')}</span>
        <input
          css={tableInput}
          type="text"
          inputMode="numeric"
          value={value}
          onChange={handleChange}
          placeholder={t('orderReview:tableNumberPlaceholder')}
        />
        <Button
          color="primary"
          disabled={!value.trim()}
          onClick={handleConfirm}
          block
        >
          OK
        </Button>
      </div>
    </Modal>
  );
};

TableNumberModal.defaultProps = {
  visible: false,
};

TableNumberModal.propTypes = {
  visible: PropTypes.bool,
  onCloseModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default TableNumberModal;
